// Action creators for the commission agencies slice.
//
// An agency is independent of any agent, so this slice is smaller than the
// agents one: list, detail, create and update — no users, banks, supervisors,
// or delete (the service exposes none).

import * as types from '../../lib/actionTypes.es6';

function creator(type) {
  return function create(payload) {
    return { type: type, payload: payload };
  };
}

// ─── Agencies list and detail ─────────────────────────────────────────────────

export var getCommissionAgenciesRequest =
  creator(types.GET_COMMISSION_AGENCIES_REQUEST);
export var getCommissionAgenciesSuccess =
  creator(types.GET_COMMISSION_AGENCIES_SUCCESS);
export var getCommissionAgenciesFailed =
  creator(types.GET_COMMISSION_AGENCIES_FAILURE);

export var getCommissionAgencyRequest =
  creator(types.GET_COMMISSION_AGENCY_REQUEST);
export var getCommissionAgencySuccess =
  creator(types.GET_COMMISSION_AGENCY_SUCCESS);
export var getCommissionAgencyFailed =
  creator(types.GET_COMMISSION_AGENCY_FAILURE);

// ─── Agency writes ─────────────────────────────────────────────────────────────

export var createCommissionAgencyRequest =
  creator(types.CREATE_COMMISSION_AGENCY_REQUEST);
export var createCommissionAgencySuccess =
  creator(types.CREATE_COMMISSION_AGENCY_SUCCESS);
export var createCommissionAgencyFailed =
  creator(types.CREATE_COMMISSION_AGENCY_FAILURE);
export var resetCreateCommissionAgencySuccess =
  creator(types.RESET_CREATE_COMMISSION_AGENCY_SUCCESS);
export var resetCreateCommissionAgencyError =
  creator(types.RESET_CREATE_COMMISSION_AGENCY_ERROR);

export var updateCommissionAgencyRequest =
  creator(types.UPDATE_COMMISSION_AGENCY_REQUEST);
export var updateCommissionAgencySuccess =
  creator(types.UPDATE_COMMISSION_AGENCY_SUCCESS);
export var updateCommissionAgencyFailed =
  creator(types.UPDATE_COMMISSION_AGENCY_FAILURE);
export var resetUpdateCommissionAgencySuccess =
  creator(types.RESET_UPDATE_COMMISSION_AGENCY_SUCCESS);
export var resetUpdateCommissionAgencyError =
  creator(types.RESET_UPDATE_COMMISSION_AGENCY_ERROR);
